import _ from 'underscore';

/**
 * 주어진 엘리먼트에서 [data-datasetName] 속성이 있는 요소를 찾아서,
 *  그 dataset의 값과 일치하는 객체의 값을 찾아서 해당 엘리먼트에 $.html 로 렌더링한다.
 * @param {*} $container jQuery 객체
 * @param {string} datasetName $container 안에서 찾을 [data-datasetName] 속성이 있는 엘리먼트
 * @param {*} data 렌더링할 정보가 들어있는 객체
 */
export function renderBoundDataset($container, datasetName, data) {
  var placeholders = $container.find('[data-' + datasetName + ']').toArray();

  _.each(placeholders, function (elm) {
    var $elm = $(elm);
    var bound = $elm.data(datasetName);
    var pickOf = _.property(bound.split('.'));
    var prop = pickOf(data);

    if (!_.isUndefined(prop)) {
      $elm.html(prop);
    }
  });
}
